import React, {useState, useEffect} from 'react';
import { Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

import BasicInformationsTab from './BasicInformationsTab';
import SpecificationTab from './SpecificationTab';
import FileTab from '../file/FileTab';
import ArticlePartTab from '../articlePart/ArticlePartTab';
import PartnerDataTab from '../partnerData/PartnerDataTab';

//import "./ArticleModal.css";
//import "bootstrap/dist/css/bootstrap.min.css";


const ArticleModal = (props) => {
   
    const [show, setShow] = useState(false);  
    const [selectedRecord, setSelectedRecord] =  useState(false);  
    const [activeTab, setActiveTab] = useState('BASIC_INFORMATIONS');
    const [t] = useTranslation();
    const [windowTitle, setWindowTitle] = useState(t('article.label.newArticle'));
    const [object, setObject] = useState([]);
    

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const loadedObject = (object) => {
        
        if(object!=null && object.id!=null && object.id!==''){
            setSelectedRecord(object.id);
            setObject(object);
        }
        try{
            if(object.name){              
                setWindowTitle(object.name);                
            }else{
                setWindowTitle(t('article.label.newArticle'));
            }
            
        }catch(error){
               console.log(error);
        }
      
    }

    const hideModal = () => {
      setShow(false);     
      props.parentCallback(false,selectedRecord);      
    };
   
    useEffect(() => {
      setShow(props.modal);
    }, [props.modal])

    useEffect(() => {
      setSelectedRecord(props.selectedRecord);
    }, [props.selectedRecord])

    return (
 
 
      <>         
                <Modal
                  show={show}
                  onHide={hideModal}
                  container={this}
                  aria-labelledby="contained-modal-title"
                //  centered
                  size="lg"                       //xl                 
                >
                    
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{windowTitle}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>

                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'BASIC_INFORMATIONS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('BASIC_INFORMATIONS')
                                                    }
                                                >
                                                    {t('article.label.article')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'SPECIFICATION'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('SPECIFICATION')
                                                    }
                                                >
                                                    {t('article.label.specification')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'FILES'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('FILES')
                                                    }
                                                >
                                                    {t('file.label.file')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'PARTS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('ARTICLE_PARTS')
                                                    }
                                                >
                                                    {t('articlePart.label.articleParts')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'PARTNERS_DATA'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('PARTNERS_DATA')
                                                    }
                                                >
                                                    {t('article.label.partnersData')}
                                                </button>
                                            </li>                                          
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <BasicInformationsTab
                                                isActive={activeTab === 'BASIC_INFORMATIONS'}
                                                parentCallback={hideModal}
                                                selectedRecord={selectedRecord}
                                                loadedObject={loadedObject}
                                            />                                                                                      
                                             <SpecificationTab
                                                isActive={activeTab === 'SPECIFICATION'}                                                
                                                parentCallback={hideModal}
                                                selectedRecord={selectedRecord}                                                
                                                object={object}
                                                loadedObject={loadedObject}
                                            />      
                                             <FileTab
                                                isActive={activeTab === 'FILES'}                                                       
                                                parentCallback={hideModal}
                                                entityId={selectedRecord}                                                
                                            />     
                                              <ArticlePartTab
                                                isActive={activeTab === 'ARTICLE_PARTS'}                                                       
                                                parentCallback={hideModal}
                                                entityId={selectedRecord}                                                
                                                object={object}
                                                loadedObject={loadedObject}                                           
                                            />    
                                              <PartnerDataTab
                                                isActive={activeTab === 'PARTNERS_DATA'}                                                       
                                                parentCallback={hideModal}
                                                entityId={selectedRecord}                                                
                                                object={object}
                                                loadedObject={loadedObject}                                           
                                            />    
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
             
                            </Modal.Body>                   
                                        
                  </Modal>   
      </>
    );
};

 
 export default ArticleModal;


 